import { __assign, __read, __rest } from "tslib";
import React, { useContext, forwardRef } from "react";
import classNames from "classnames";
import { useRefAndForward } from "../_util/use-ref-and-forward";
import { useDefaultValue, } from "../form/controlled";
import { Tooltip } from "../tooltip";
import { callBoth } from "../_util/call-both";
import { useConfig } from "../_util/config-context";
import { useIsomorphicLayoutEffect } from "../_util/use-isomorphic-layout-effect";
/**
 * Check 组件支持使用 CheckContext 进行状态托管
 */
export var CheckContext = React.createContext(null);
export var Check = forwardRef(function (_props, ref) {
    var _a;
    var classPrefix = useConfig().classPrefix;
    // 支持从 Context 注入
    var context = useContext(CheckContext);
    var props = _props;
    if (context) {
        props = context.inject(_props);
    }
    var _b = useDefaultValue(props, false), value = _b.value, onChange = _b.onChange, type = _b.type, indeterminate = _b.indeterminate, children = _b.children, className = _b.className, _c = _b.disabled, disabled = _c === void 0 ? false : _c, onClick = _b.onClick, display = _b.display, _d = _b.style, style = _d === void 0 ? {} : _d, inputRef = _b.inputRef, tooltip = _b.tooltip, tabIndex = _b.tabIndex, htmlProps = __rest(_b, ["value", "onChange", "type", "indeterminate", "children", "className", "disabled", "onClick", "display", "style", "inputRef", "tooltip", "tabIndex"]);
    // handle indeterminate
    var _e = __read(useRefAndForward(null, inputRef), 2), checkInputRef = _e[0], forwardInputRef = _e[1];
    useIsomorphicLayoutEffect(function () {
        if (type === "checkbox" && checkInputRef.current) {
            checkInputRef.current.indeterminate = indeterminate;
        }
    });
    var labelClassName = classNames(classPrefix + "-form-check", (_a = {},
        _a[classPrefix + "-form-check--block"] = display === "block",
        _a), className);
    var input = (React.createElement("input", { readOnly: true, ref: forwardInputRef, type: type, className: classPrefix + "-" + type, checked: value, disabled: disabled, style: disabled ? { pointerEvents: "none" } : {}, tabIndex: tabIndex, onClick: callBoth(onClick, function (event) {
            return onChange(event.currentTarget.checked, {
                event: event,
                check: __assign(__assign({}, props), { value: event.currentTarget.checked }),
            });
        }) }));
    var check = (React.createElement("label", __assign({ ref: ref, className: labelClassName, style: disabled ? __assign({ cursor: "not-allowed" }, style) : style }, htmlProps, { onClick: function (event) { return event.stopPropagation(); } }),
        type === "radio" ? (React.createElement("span", { className: classPrefix + "-radio-wrap" },
            input,
            React.createElement("i", { className: classPrefix + "-radio__dot" }))) : (input),
        React.createElement("span", { key: "label", className: classPrefix + "-form-check__label", style: disabled ? { cursor: "not-allowed" } : {} }, children)));
    if (tooltip) {
        check = React.createElement(Tooltip, { title: tooltip }, check);
    }
    return check;
});
Check.displayName = "Check";
//# sourceMappingURL=Check.js.map